import { typographyToCss } from 'shared/lib/mui';
import styled from 'styled-components';

export const Container = styled.article<{ $isClickable: boolean }>`
  width: 100%;
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(2)};

  padding: ${({ theme }) => `${theme.spacing(1.5)} ${theme.spacing(2)}`};

  border-radius: ${({ theme }) => theme.spacing(2)};
  cursor: ${({ $isClickable }) => ($isClickable ? 'pointer' : 'default')};
  transition: background 200ms;

  color: ${({ theme }) => theme.palette.text.primary};

  &:hover {
    background: ${({ theme }) => theme.palette.grey[100]};
  }

  &:focus {
    outline: none;
    background: ${({ theme }) => theme.palette.grey[100]};
  }
`;

export const Title = styled.h1`
  ${({ theme }) => typographyToCss(theme.typography.body2)};
  flex: 1;

  padding: 0;
  margin: 0;

  cursor: inherit;
  overflow: hidden;

  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const IconContainer = styled.div<{ $color: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 2rem;
  width: 2rem;

  color: ${({ $color }) => $color};
`;
